import { render, staticRenderFns } from "./applink-content.vue?vue&type=template&id=51fdc5a4&scoped=true"
import script from "./applink-content.vue?vue&type=script&lang=ts"
export * from "./applink-content.vue?vue&type=script&lang=ts"
import style0 from "./applink-content.vue?vue&type=style&index=0&id=51fdc5a4&prod&lang=css"
import style1 from "./applink-content.vue?vue&type=style&index=1&id=51fdc5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fdc5a4",
  null
  
)

export default component.exports